<template lang="pug">
  .kimple-folder-feed.card-container
    .row.space-between.middle.m-bottom-2
      .placeholder.folder
    .placeholder.title.m-bottom-1
    .placeholder.subtitle
    .placeholder.ages.m-top-auto
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.kimple-folder-feed{
  background-color: $white;
  justify-content: flex-start;
  border-radius: 8px;
  height: 220px;
  padding: 20px;
  margin: 0;
}

.placeholder {
  background-color: $light-gray;

  &.title{
    height: 25px;
    width: 150px;
  }
  &.subtitle{
    height: 18px;
    width: 100px;
  }
  &.folder{
    width: 30px;
    border-radius: 50%;
    height: 30px;
  }
  &.ages{
    width: 95%;
    height: 20px;
  }
}
</style>
